import React from "react";
import {menuItemsInfo} from "../editMenuItems";
import {ParamAssignmentsPanel} from "../components/ParamAssignmentsPanel";

export const InputParamsTab = ({node, onUpdate, project}) => {
    const {primary, secondary} = menuItemsInfo.input_params;
    return (
        <ParamAssignmentsPanel
            node={node}
            onUpdate={onUpdate}
            project={project}
            dataKey="inputs"
            title={primary}
            description={secondary}
        />
    );
};
